import { useQuery } from '@tanstack/react-query';
import { dataCentralApi } from '@/api/client';
import type { ResponseArray } from '@/types/shared';

/**
 * Product groups — the catalog of sellable service categories. A journey's
 * `service_interestings` are `product_group_name` strings picked from this list
 * (legacy `getProductsGroupOptions` uses the name as both label and value), so
 * the deal-info / create-journey pickers must source their options from here,
 * not a hardcoded slug list.
 */

export interface ProductGroup {
  product_group_id?: number;
  product_group_name: string;
  [key: string]: unknown;
}

export interface ProductGroupOption {
  value: string;
  label: string;
}

/** `GET /product-groups` — options keyed by `product_group_name` (label = value). */
export function useProductGroupOptions() {
  return useQuery({
    queryKey: ['product-groups', 'options'],
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<ProductGroupOption[]> => {
      const res = await dataCentralApi.get<ResponseArray<ProductGroup>>(
        '/product-groups?page=1&page_size=200',
      );
      return (res.data.results ?? [])
        .map((g) => g.product_group_name)
        .filter(Boolean)
        .map((name) => ({ value: name, label: name }));
    },
  });
}
